import React from 'react'
/* import { Preloading } from 'react-theme-bootstrap'
import { loadingURL } from '../../utils'

const LoadingIcon = _ => {
  return <Preloading image={
    loadingURL()
  } />
} */

const LoadingIcon = _ => {
  return (
    <div className="head-dash-preloading">
      <i className="fas fa-ticket-alt fa-3x text-primary spin"></i>
    </div>
  )
}

export default LoadingIcon